module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "container",
    class: {
      containerExpand: _vm.isExpand
    }
  }, [_c('Collapse', {
    attrs: {
      "data": {
        isExpand: true,
        name: this.data.name
      }
    },
    on: {
      "activeSwitch": _vm.activeChange
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "entypo-upload",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.applyProduct
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('label', {
    staticClass: "entypo-credit-card"
  }, [_vm._v("名称")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": _vm.name
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "entypo-vcard"
  }, [_vm._v("说明")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": _vm.introduction
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1001da9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/save.vue
// module id = 99
// module chunks = 0